var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"sub-menu"},[_c('router-link',{attrs:{"to":"/tickets","custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('div',{class:{ active: isExactActive },on:{"click":navigate}},[_vm._v(" My tickets ")])]}}])}),_c('router-link',{attrs:{"to":"/tickets/all","custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('div',{class:{ active: isExactActive },on:{"click":navigate}},[_vm._v(" All tickets ")])]}}])}),_c('router-link',{attrs:{"to":"/tickets/search","custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('div',{class:{ active: isExactActive },on:{"click":navigate}},[_vm._v(" Search tickets ")])]}}])}),_c('router-link',{attrs:{"to":"/tickets/new","custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('div',{class:{ active: isExactActive },on:{"click":navigate}},[_vm._v(" Create new ticket ")])]}}])}),(_vm.$route.name === 'View ticket')?_c('div',{staticClass:"active"},[_vm._v(" View ticket ")]):_vm._e()],1),_c('router-view')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }